import React, { Component } from 'react';
import { Modal, Button, Select, Icon, message, Input, Row, Col, Spin } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;
const TextArea = Input.TextArea;

let visitTypeIds = [];
let visitTypeNames = [];
let visitGroupingNames = [];

class RelateVisit extends Component {
    state = {
        record: {},
        params: {},
        loading: false,
        visible: false,
        visitType: [],
        manHourVisits: [],
    }

    show = (params, type) => {
        const { manHourVisits, ...record } = params;
        type === 'add' && this.filterVisitList(manHourVisits);
        this.setState({
            type,
            record,
            params: {},
            visible: true,
            manHourVisits: manHourVisits ? [...manHourVisits] : [],
        }, () => {
            type === 'edit' && this.loadData();
        });
    }

    hide = () => {
        visitTypeIds = [];
        visitTypeNames = [];
        visitGroupingNames = [];
        this.setState({
            visible: false,
            manHourVisits: [],
        });
    }

    loadData = () => {
        const { record: { manHourId } } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.manhour.listManHourVisit,
            data: { manHourId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.filterVisitList(data);
                this.setState({
                    loading: false,
                    manHourVisits: data,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryVisitType = () => {
        const { record: { investigationId }, params: { userId, schemaName } } = this.state;
        const options = {
            url: API_URL.manhour.queryVisitNameByuserId,
            data: {
                investigationId,
                userId,
                schemaName,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({ visitType: data });
            },
        };
        $.sendRequest(options);
    }

    filterVisitList = (data) => {
        visitTypeIds.length = 0;
        visitTypeNames.length = 0;
        visitGroupingNames.length = 0;
        (data || []).forEach(i => {
            (i.visitTypeIds || []).forEach(j => {
                if (visitTypeIds.indexOf(j) === -1) {
                    visitTypeIds.push(j);
                }
            });
            (i.visitTypeNames || []).forEach(j => {
                if (visitTypeNames.indexOf(j) === -1) {
                    visitTypeNames.push(j);
                }
            });
            (i.visitGroupingNames || []).forEach(j => {
                if (visitGroupingNames.indexOf(j) === -1) {
                    visitGroupingNames.push(j);
                }
            });
        });
    }

    handleChange = (option) => {
        const { params } = this.state;
        const { value, text, schemaName, visitGroupingName } = option;
        params.userId = value;
        params.patientCode = text;
        params.schemaName = schemaName;
        params.visitGroupingNames = visitGroupingName ? [visitGroupingName] : null;
        params.visitTypeIds = null;
        params.visitTypeNames = null;
        this.setState({ params }, () => {
            const { params: { userId } } = this.state;
            if (userId) {
                this.queryVisitType();
            } else {
                this.setState({ visitType: [] });
            }
        });
    }
    
    handleSelectChange = (value, key) => {
        const { params, visitType } = this.state;
        const option = visitType.find(i => i.visitTypeId == value) || {};
        const { visitTypeId, visitTypeName } = option;
        params.visitTypeIds = visitTypeId ? [visitTypeId] : null;
        params.visitTypeNames = visitTypeName ? [visitTypeName] : null;
        this.setState({ params });
    }

    handleAddBtn = () => {
        const { type, params, record, manHourVisits } = this.state;
        const { userId, patientCode, visitTypeIds: pVisitTypeIds, visitTypeNames: pVisitTypeNames, visitGroupingNames: pVisitGroupingNames } = params;
        if (visitTypeIds.length > 1) {
            message.warning('每次工时记录只能记录相同的访视次数');
            return;
        }
        if (!userId) {
            message.warning('请选择筛选编号');
            return;
        } else if (!visitTypeIds.length && !pVisitTypeIds) {
            message.warning('请选择访视次数');
            return;
        }
        if (type === 'add') {
            let flag = manHourVisits.some(i => i.userId == userId);
            if (flag) {
                message.warning('已关联相同的患者（访视），请勿重复添加');
                return;
            } else {
                manHourVisits.push({
                    userId,
                    patientCode,
                    visitTypeIds: (visitTypeIds.length && [...visitTypeIds]) || pVisitTypeIds,
                    visitTypeNames: (visitTypeNames.length && [...visitTypeNames]) || pVisitTypeNames,
                    visitGroupingNames: (visitGroupingNames.length && [...visitGroupingNames]) || pVisitGroupingNames,
                });
            }
            this.setState({
                params: {},
                manHourVisits,
            });
            if (!visitTypeIds.length) {
                visitTypeIds.push.apply(visitTypeIds, pVisitTypeIds);
                visitTypeNames.push.apply(visitTypeNames, pVisitTypeNames);
                visitGroupingNames.push.apply(visitGroupingNames, pVisitGroupingNames);
            }
            this.props.saveVisitData(manHourVisits);
        } else {
            const { manHourId } = record;
            const params = {
                'manHourVisits[0].userId': userId,
                'manHourVisits[0].patientCode': patientCode,
                'manHourVisits[0].manHourVisitDetails[0].visitTypeId': ((visitTypeIds.length && visitTypeIds) || pVisitTypeIds).join(','),
            };
            this.setState({ loading: true });
            const options = {
                url: API_URL.manhour.addManHourVisit,
                data: {
                    manHourId,
                    ...params,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.setState({
                        params: {},
                        loading: false,
                    }, () => {
                        this.props.loadData();
                        this.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        }
    }

    handleRemoveItem = (param) => {
        const { type, manHourVisits } = this.state;
        if (type == 'add') {
            manHourVisits.splice(param, 1);
            this.filterVisitList(manHourVisits);
            this.setState({ manHourVisits }, () => {
                this.props.saveVisitData(manHourVisits);
            });
        } else {
            if (manHourVisits.length === 1) {
                message.warning('已添患者(访视)不能为空!');
                return;
            }
            this.setState({ loading: true });
            const options = {
                url: API_URL.manhour.deleteManHourVisit,
                data: { manHourVisitId: param },
                dataType: 'json',
                doneResult: ( res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.props.loadData();
                        this.loadData();
                    });
                }),
                errorResult: () => {
                    this.setState({ loading: false }); 
                }
            };
            $.sendRequest(options);
        }
    }

    getDataList = () => {
        const { type, manHourVisits } = this.state;
        const data = (manHourVisits || []).map((item, index) => {
            const { manHourVisitId, patientCode, visitTypeNames } = item;
            return (
                <div className="item-btn" key={type === 'add' ? index : manHourVisitId} style={{maxWidth: 235}}>
                    <Icon className="item-icon" type="close-circle-o" onClick={() => this.handleRemoveItem(type === 'add' ? index : manHourVisitId)}/>
                    <div>{`${patientCode}(${(visitTypeNames || []).join(',')})`}</div>
                </div>
            )
        });
        return data;
    }

    render() {
        const { visible, loading, params, record, visitType } = this.state;
        const { investigationId, investigationSiteId } = record;
        const { userId, patientCode, visitTypeIds: pVisitTypeIds, visitGroupingNames: pVisitGroupingNames } = params;
        const options = visitType.map(i => <Option key={i.visitTypeId}>{i.visitTypeName}</Option>)  
        return (
            <Modal
                title="关联患者（访视）"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="440px"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <div className="modal-content">
                    <Spin spinning={loading}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <Icon type="exclamation-circle-o" style={{position: 'absolute', top: 22, fontSize: 24, color: '#F00'}} />
                                <div style={{marginLeft: 30}}>
                                <p >请选择该中心下的患者(访视)，若无患者(访视)选项，请先登记患者</p>
                                <p >的访视记录<span style={{color:'#F00'}}>【每次工时记录只能记录相同的访视次数】</span></p>
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left" style={{width: 86}}>筛选编号:</div>
                                <div className="item-right" style={{width: 160}}>
                                    <SearchRetrieve
                                        keyword='keyword'
                                        style={{ width: 160 }}
                                        placeholder="输入筛选编号检索"
                                        value={patientCode}
                                        params={{ limit: 20, visitTypeId: visitTypeIds.join(','), investigationId, investigationSiteId }}
                                        url={API_URL.manhour.queryPatientBySiteId}
                                        config={{ id: 'userId', name: 'patientCode', type: 'patientVisit' }}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </li>
                            {
                                (visitGroupingNames.length === 1 || pVisitGroupingNames) &&
                                <li className="modal-item">
                                    <div className="item-left" style={{width: 86}}>访视分组:</div>
                                    <div className="item-right" style={{width: 160}}>
                                        {(visitGroupingNames.length === 1 && visitGroupingNames.join(',')) || pVisitGroupingNames.join(',')}
                                    </div>
                                </li>
                            }
                            <li className="modal-item" style={{position:'relative'}}>
                                <div className="item-left" style={{width: 86}}>访视次数:</div>
                                <div className="item-right" style={{width: 160}}>
                                    {
                                        visitTypeIds.length ?
                                            visitTypeNames.length === 1 && visitTypeNames.join(',')
                                        :
                                            <Select
                                                disabled={!userId}
                                                allowClear={true}
                                                placeholder="输入访视次数检索"
                                                style={{ width: 160 }}
                                                showSearch
                                                filterOption= {(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                value={pVisitTypeIds ? pVisitTypeIds.join(',') : undefined}
                                                onChange={value => this.handleSelectChange(value, 'visitTypeId')}
                                            >
                                                {options}
                                            </Select>
                                    }
                                </div>
                                <Button type="primary" onClick={this.handleAddBtn} style={{position:'absolute',top:5,right:10}}>添加患者(访视)</Button>
                            </li>
                            <div style={{margin: '10px 0', borderBottom: '1px solid #d1d1d1'}} />
                            <li className="modal-item" style={{ padding: '8px 0' }}>
                                <div className="item-left" style={{width: 110, paddingRight: 10}}>已添患者（访视）:</div>
                                <div className="item-right">
                                    { this.getDataList() }
                                </div>
                            </li>
                        </ul>
                    </Spin>
                </div>
            </Modal>
        );
    }
}

class OtherExplain extends Component {
    state = {
        visible: false,
    };

    show = params => {
        const { manHourId } = params;
        let type = ''
        if (!manHourId) {
            type = 'add';
        } else {
            type = 'edit';
        }
        this.setState({
            type,
            params,
            visible: true,
        })
    };

    hide = () => {
        this.setState({ visible: false });
    };

    handleSubmit = () => {
        const { type, params = {} } = this.state;
        const { remarks = '' } = params;
        if (remarks.trim() == '') {
            message.warning('请填写其他说明');
            return;
        }

        if (type == 'add') {
            this.props.saveRemarks(remarks);
            this.setState({ visible: false });
        } else {
            const options = {
                url: API_URL.manhour.updateManHourRemarks,
                data: { ...params },
                dataType: 'json',
                doneResult: ( res => {
                    if (!res.error) {
                        message.success(res.success);
                        this.setState({ visible: false });
                        this.props.reLoad();
                    } else {
                        message.error(res.error);
                    }
                }),
            };
            $.sendRequest(options);
        }
    }

    onTextAreaChange = e => {
        const { params } = this.state;
        params.remarks = e.target.value;
        this.setState({ params });
    }

    render() {
        const { visible, params = {}, type = '' } = this.state;
        const { remarks = '' } = params;
        return (
            <Modal
                title="其他说明"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                maskClosable={false}
                closable={type == 'add' ? false : true}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                footer={<div>
                    { type == 'edit' && <Button key="cancel" type="ghost" size="large" onClick={this.hide}>关闭</Button> }
                    <Button key="confirm" type="primary" size="large" onClick={this.handleSubmit}>确认</Button>
                </div>}
            >
                <Row>
                    <Col span={5}><span style={{color: '#f00'}}>*</span>其他说明:</Col>
                    <Col span={18}>
                        <TextArea placeholder="请填写其他说明" value={remarks} rows={4} onChange={this.onTextAreaChange} />
                    </Col>
                </Row>
            </Modal>
        );
    }
}

export { RelateVisit, OtherExplain };



// WEBPACK FOOTER //
// ./src/components/manHour/writeManhour/Widget.js